module.exports = __webpack_public_path__ + "img/received.4191408f.png";